interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

const gridSizes = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-9 w-9',
};

const textSizes = {
  sm: 'text-sm',
  md: 'text-base',
  lg: 'text-xl',
};

// fattura 3×3 pattern: ●●● / ●●○ / ●○○ (lettera "F" — fattura)
const DOTS: [number, number, boolean][] = [
  [5,  5,  true ], [15, 5,  true ], [25, 5,  true ],
  [5,  15, true ], [15, 15, true ], [25, 15, false],
  [5,  25, true ], [15, 25, false], [25, 25, false],
];

function PragmoGrid({ className = '' }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 30 30"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {DOTS.map(([cx, cy, lit], i) => (
        <circle
          key={i}
          cx={cx}
          cy={cy}
          r={3}
          fill={lit ? '#378ADD' : 'currentColor'}
          opacity={lit ? 1 : 0.25}
        />
      ))}
    </svg>
  );
}

export function Logo({ className = '', size = 'md' }: LogoProps) {
  return (
    <div className={`flex items-center gap-2.5 text-foreground ${className}`}>
      <PragmoGrid className={gridSizes[size]} />
      <div className="flex flex-col leading-none gap-0.5">
        <span className={`font-medium tracking-tight ${textSizes[size]}`}>
          fattura
        </span>
        <span className="text-[10px] text-muted-foreground font-mono leading-none">
          .pragmo.app
        </span>
      </div>
    </div>
  );
}

export function LogoIcon({ className = '', size = 'md' }: LogoProps) {
  return (
    <PragmoGrid className={`${gridSizes[size]} text-foreground ${className}`} />
  );
}
